module.exports = __webpack_public_path__ + "img/sld_scb_22_t1_b1.aa6339a4.svg";